import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRACTICE } from "@/data/site";
import { useT } from "@/i18n/LanguageContext";

export default function SpecialOffer() {
  const { t } = useT();
  return (
    <section
      id="special"
      data-testid="special-offer-section"
      className="px-6 md:px-10 lg:px-16 py-20 md:py-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="relative overflow-hidden rounded-[28px] md:rounded-[36px] bg-[var(--primary)] text-[var(--bg)] p-7 sm:p-10 md:p-16 grain"
      >
        <div className="absolute -top-20 -right-20 w-[300px] h-[300px] rounded-full bg-[var(--accent)]/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-10 w-[260px] h-[260px] rounded-full bg-[var(--accent)]/10 blur-3xl" />

        {/* gold smile arc decoration */}
        <svg
          className="absolute right-10 top-10 opacity-50 hidden md:block"
          width="240"
          height="60"
          viewBox="0 0 240 60"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M4 4 C 40 60, 200 60, 236 4"
            stroke="var(--accent)"
            strokeWidth="1.6"
            strokeLinecap="round"
            fill="none"
          />
        </svg>

        <div className="relative grid md:grid-cols-2 gap-10 items-end">
          <div>
            <div className="font-mono-eyebrow text-[var(--accent)] flex items-center gap-3">
              <span className="w-8 h-px bg-[var(--accent)]" />
              {t("New patient special")}
            </div>
            <h2 className="font-serif-display mt-5 text-[48px] md:text-[88px] leading-[0.95] tracking-tight">
              <span className="italic text-[var(--accent)]">$</span>129
            </h2>
            <p className="mt-3 text-[20px] md:text-[26px] font-serif-display text-[var(--bg)]/90">
              {t("Comprehensive Exam · Digital X-Rays · Cleaning")}
            </p>
          </div>
          <div className="md:text-right">
            <p className="text-[var(--bg)]/75 max-w-md md:ml-auto">
              {t("A relaxed, no-rush first visit. We listen, we explain, and we build a plan that fits your life — not the other way around.")}
            </p>
            <div className="mt-7 flex flex-wrap md:justify-end gap-3">
              <a
                data-testid="offer-book-btn"
                href={PRACTICE.appointmentUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[var(--accent)] text-[var(--primary)] font-medium hover:bg-[var(--accent-hover)] hover:text-[var(--bg)]"
              >
                {t("Claim Offer")} <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                data-testid="offer-call-btn"
                href={PRACTICE.phoneHref}
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-[var(--bg)]/40 text-[var(--bg)] hover:bg-[var(--bg)] hover:text-[var(--primary)]"
              >
                {t("Call")} {PRACTICE.phone}
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
